"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginTypeSelector = exports.commonReducer = void 0;
var _reselect = require("reselect");
var _const = require("../../../common/redux/const");
const commonReducer = state => state[_const.ASTER_CORE_REDUCER];
exports.commonReducer = commonReducer;
const loginTypeSelector = () => (0, _reselect.createSelector)(commonReducer, item => {
  var _item$getLoginType;
  return (item === null || item === void 0 || (_item$getLoginType = item.getLoginType) === null || _item$getLoginType === void 0 || (_item$getLoginType = _item$getLoginType.data) === null || _item$getLoginType === void 0 ? void 0 : _item$getLoginType.type) || '';
});
exports.loginTypeSelector = loginTypeSelector;